import './App.css'
import ChessGame from './ChessGame'

function App() {

  return (
    <>
    <div id="header">
      Created by <span id="name">Maher Hazem</span>. More of my work <a href="https://glittering-biscuit-f63091.netlify.app/en/" target='blank_' id="portfolioLink">here</a>
    </div>
    <ChessGame />
    </>
  )
}

export default App